import { Deserializable } from '../deserializable';

export class TransactionsDto implements Deserializable {
  public CaseNumber?: number;
  public CaseNumberHash: string;
  public CaseType: string;
  public CaseStatus: string;
  public DateCreated: Date;
  public Originator: string;
  public Firm: string;
  public NumberOfMessages?: number;
  public CaseOwner: string;
  public Description: string;
  public IsCaseTransaction: boolean;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
